import type { ReactNode } from 'react';

/*
 * Ikony.
 *
 * Vlastne SVG, jednotna mriezka 24x24, `currentColor` a hrubka 1.75.
 * Emoji sa nepouzivaju nikde, bez vynimky - poziadavka z CLAUDE.md.
 *
 * Ikony su vzdy `aria-hidden`: nesu vyznam len spolu s textom, a ked
 * stoja samy (ikonove tlacidlo), popis nesie `aria-label` tlacidla.
 */

interface IkonaProps {
  readonly className?: string;
}

function Svg({ children, className }: { readonly children: ReactNode } & IkonaProps): ReactNode {
  return (
    <svg
      className={className ?? 'size-5'}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export const IconDashboard = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="M4 13h6V4H4zM14 20h6v-9h-6zM4 20h6v-4H4zM14 8h6V4h-6z" />
  </Svg>
);

export const IconPlug = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="M9 3v6M15 3v6M6 9h12v3a6 6 0 0 1-12 0zM12 18v3" />
  </Svg>
);

export const IconBulb = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.6.5.9 1.2.9 1.9V16h5.2v-.2c0-.7.3-1.4.9-1.9A6 6 0 0 0 12 3Z" />
  </Svg>
);

export const IconLink = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="M10 13a4 4 0 0 0 5.7.4l3-3a4 4 0 0 0-5.7-5.7L11.3 6.4" />
    <path d="M14 11a4 4 0 0 0-5.7-.4l-3 3a4 4 0 0 0 5.7 5.7l1.7-1.7" />
  </Svg>
);

export const IconServer = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <rect x="3" y="4" width="18" height="7" rx="2" />
    <rect x="3" y="13" width="18" height="7" rx="2" />
    <path d="M7 7.5h.01M7 16.5h.01" />
  </Svg>
);

export const IconList = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="M8 6h13M8 12h13M8 18h13M3.5 6h.01M3.5 12h.01M3.5 18h.01" />
  </Svg>
);

export const IconGear = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-1.8-.3 1.6 1.6 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1A1.6 1.6 0 0 0 9 19.4a1.6 1.6 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.6 1.6 0 0 0 .3-1.8 1.6 1.6 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1A1.6 1.6 0 0 0 4.6 9a1.6 1.6 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.6 1.6 0 0 0 1.8.3H9a1.6 1.6 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.6 1.6 0 0 0 1 1.5 1.6 1.6 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0-.3 1.8V9a1.6 1.6 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.6 1.6 0 0 0-1.5 1Z" />
  </Svg>
);

export const IconArchive = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <rect x="3" y="4" width="18" height="4" rx="1" />
    <path d="M5 8v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8M10 12h4" />
  </Svg>
);

export const IconLayers = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="m12 3 9 5-9 5-9-5 9-5ZM3 13l9 5 9-5M3 17l9 5 9-5" />
  </Svg>
);

export const IconMenu = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="M4 6h16M4 12h16M4 18h16" />
  </Svg>
);

export const IconClose = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="M6 6l12 12M18 6 6 18" />
  </Svg>
);

export const IconLogout = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
  </Svg>
);

export const IconRefresh = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="M3 12a9 9 0 0 1 15.5-6.2L21 8M21 4v4h-4M21 12a9 9 0 0 1-15.5 6.2L3 16M3 20v-4h4" />
  </Svg>
);

export const IconDownload = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="M12 3v12M7 11l5 5 5-5M4 21h16" />
  </Svg>
);

export const IconCheck = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="M5 12.5 10 17.5 19 6.5" />
  </Svg>
);

export const IconAlert = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="M12 9v4.5M12 17.5h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
  </Svg>
);

export const IconChevronRight = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="m9 5 7 7-7 7" />
  </Svg>
);

export const IconPlus = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="M12 5v14M5 12h14" />
  </Svg>
);

export const IconTrash = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="M4 7h16M10 11v6M14 11v6M5 7l1 13a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1l1-13M9 7V4h6v3" />
  </Svg>
);

export const IconPencil = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="M4 20h4L20 8a2.8 2.8 0 0 0-4-4L4 16v4Z" />
  </Svg>
);

export const IconThermometer = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="M14 14.8V5a2 2 0 1 0-4 0v9.8a4 4 0 1 0 4 0Z" />
  </Svg>
);

export const IconMatter = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="M12 3 4.5 7.5v9L12 21l7.5-4.5v-9Z" />
    <path d="M12 8.2 8.5 10.2v3.6L12 15.8l3.5-2V10.2Z" />
  </Svg>
);

export const IconExternal = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="M14 4h6v6M20 4l-8.5 8.5" />
    <path d="M18 14.5V18a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.5" />
  </Svg>
);

export const IconRadio = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="1.6" />
    <path d="M8.8 15.2a4.5 4.5 0 0 1 0-6.4M15.2 8.8a4.5 4.5 0 0 1 0 6.4" />
    <path d="M6 18a8.5 8.5 0 0 1 0-12M18 6a8.5 8.5 0 0 1 0 12" />
  </Svg>
);

export const IconCloudSun = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="M7 6.5a3.5 3.5 0 0 1 6.6 1.3M4.2 9.8 3 9M7 3.5V2.2M10.8 6 11.7 5M3.4 5 4.3 6" />
    <path d="M17.5 19H8a4 4 0 0 1 0-8 5.2 5.2 0 0 1 9.9 1.2 3.4 3.4 0 0 1-.4 6.8Z" />
  </Svg>
);

export const IconPower = (p: IkonaProps): ReactNode => (
  <Svg {...p}>
    <path d="M12 3v9M6.5 6.6a8 8 0 1 0 11 0" />
  </Svg>
);

/**
 * Bateria s naplnou.
 *
 * Naplnu kresli obdlznik vnutri: siroky podla percent. Nie je to
 * ozdoba - z ikony sa da precitat stav aj bez toho, aby clovek citelal
 * cislo vedla nej.
 */
export const IconBattery = ({
  percent,
  className,
}: IkonaProps & { readonly percent: number }): ReactNode => {
  const sirka = Math.max(0, Math.min(100, percent)) * 0.12; // 0-12 jednotiek
  return (
    <Svg {...(className !== undefined ? { className } : {})}>
      <rect x="2" y="8" width="16" height="8" rx="2" />
      <path d="M20.5 11v2" />
      {sirka > 0 && (
        <rect x="4" y="10" width={sirka} height="4" rx="1" fill="currentColor" stroke="none" />
      )}
    </Svg>
  );
};

/**
 * Snímanie QR kódu kamerou.
 *
 * Rohy hľadáčika a v strede značka kódu — vlastná kresba, nie emoji.
 */
export const IconQr = (p: IkonaProps): ReactNode => (
  <Svg {...(p.className !== undefined ? { className: p.className } : {})}>
    <path d="M3 8V5a2 2 0 0 1 2-2h3" />
    <path d="M16 3h3a2 2 0 0 1 2 2v3" />
    <path d="M21 16v3a2 2 0 0 1-2 2h-3" />
    <path d="M8 21H5a2 2 0 0 1-2-2v-3" />
    <rect x="7.5" y="7.5" width="4" height="4" rx="0.5" />
    <path d="M14 14h2.5v2.5" />
    <path d="M7.5 14.5h1.5" />
    <path d="M14 7.5h2.5" />
  </Svg>
);
